import { useEffect } from "react";
import TopNav from "./components/TopNav";
import HeroSection from "./sections/HeroSection";
import FeaturesSection from "./sections/FeaturesSection";
import IntegrationBanner from "./sections/IntegrationBanner";
import WhyUsSection from "./sections/WhyUsSection";
import PricingSection from "./sections/PricingSection";
import TeamSection from "./sections/TeamSection";
import FaqsSection from "./sections/FaqsSection";
import FooterSection from "./sections/FooterSection";

export default function LandingHomeFinal() {
  useEffect(() => {
    const prev = document.title;
    document.title = "Shadow · completes your to-dos before you finish the call";
    return () => {
      document.title = prev;
    };
  }, []);

  return (
    <div className="min-h-screen bg-white font-sans text-neutral-900 antialiased">
      <TopNav />
      <main>
        <HeroSection />
        <FeaturesSection />
        <IntegrationBanner />
        <WhyUsSection />
        <PricingSection />
        <TeamSection />
        <FaqsSection />
      </main>
      <FooterSection />
    </div>
  );
}
